// ========================================
// Navigation Component
// ========================================
// Main navigation bar for the application

import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';
import './Navigation.css';

const Navigation = () => {
  const { logout, userProfile } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/login');
    } catch (err) {
      console.error('Logout failed:', err);
    }
  };

  const isActive = (path: string) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  return (
    <nav className="navigation glass-panel">
      <div className="nav-container">
        <div className="nav-brand">
          <Link to="/dashboard" className="brand-link">
            Passage
          </Link>
        </div>

        <div className="nav-links">
          <Link to="/dashboard" className={isActive('/dashboard')}>
            Dashboard
          </Link>
          <Link to="/checkin" className={isActive('/checkin')}>
            Check-in
          </Link>
          <Link to="/gratitude" className={isActive('/gratitude')}>
            Gratitude
          </Link>
          <Link to="/resentments" className={isActive('/resentments')}>
            Resentments
          </Link>
        </div>

        <div className="nav-user">
          <Link to="/settings" className="user-link">
            <span className="user-name">{userProfile?.name || 'User'}</span>
          </Link>
          <button onClick={handleLogout} className="logout-btn glass-button-sm">
            Sign Out
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
